import React from "react";

export const ImagePreview = ({ src, open, onClose }) => {
  if (!open) return null;

  const getFilename = (path) => {
    try {
      return decodeURIComponent(path.split("/").pop() || "Image");
    } catch {
      return "Image";
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100dvw",
        height: "100dvh",
        backgroundColor: "#000C",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
        backdropFilter: "blur(5px)"
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
          fontSize: "1rem",
          background: "transparent",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
        aria-label="Close preview"
      >
        <i className="icon-light-cross"></i>
      </button>

      <img
        src={src}
        alt={getFilename(src)}
        style={{
          height: "100%",
          // background: "magenta",
          maxWidth: "97dvw",
          maxHeight: "85dvh",
          objectFit: "contain",
          borderRadius: "6px",
        }}
      />
      <div
        style={{
          position: "fixed",
          bottom: "1rem",
          left: "0",
          width: "100%",
          fontSize: "0.7rem",
          fontWeight: "bold",
          color: "#fff",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          padding: "0.4rem 0.8rem",
          borderRadius: "4px",
        }}
      >
        {getFilename(src)}
      </div>
    </div>
  );
};